import FullLoading from "../../../../../../components/FullLoading";
import EventCardWithTickets from "../../../../../events/components/EventCardWithTickets";
import useEventsByUserOrganizationId from "../../hooks/useEventsByUserOrganizationId";

interface CollaboratorEventsProps {
  userOrganizationId?: string;
}

export default function CollaboratorEvents({
  userOrganizationId,
}: CollaboratorEventsProps) {
  const { data: events, loading: eventsLoading } =
    useEventsByUserOrganizationId(userOrganizationId);

  if (eventsLoading) return <FullLoading />;

  if (!events) {
    return (
      <div className="text-secondary text-sm">
        Pas d'évènements en commun pour le moment
      </div>
    );
  }

  const nonNullEvents = events.eventsByUserOrganizationId.filter(
    (event) => event !== null
  );

  if (nonNullEvents.length === 0)
    return (
      <div className="text-secondary text-sm">
        Pas d'évènements en commun pour le moment
      </div>
    );

  return (
    <div className="flex flex-wrap gap-4">
      {nonNullEvents.map((event) => (
        <EventCardWithTickets key={event.id} event={event} />
      ))}
    </div>
  );
}
